var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Dropdown as FluentDropdown, ResponsiveMode } from "@fluentui/react";
import { configParameters, copyProps, remoteConfig } from "../../utils/common";
export var DropDownMode;
(function (DropDownMode) {
    DropDownMode["RESPONSIVE"] = "responsive";
    DropDownMode["STATIC"] = "static";
})(DropDownMode || (DropDownMode = {}));
var styles = {
    dropdownOptionText: {
        wordBreak: "normal",
        whiteSpace: "normal"
    },
};
export var Dropdown = function (props) {
    var config = remoteConfig();
    var forwardProps = copyProps(props, {});
    delete forwardProps.styles;
    if (!forwardProps.responsiveMode && config.getString(configParameters.dropdownMode) === DropDownMode.STATIC) {
        forwardProps.responsiveMode = ResponsiveMode.large;
    }
    return _jsx(FluentDropdown, __assign({ styles: __assign(__assign({}, styles), props.styles) }, forwardProps), void 0);
};
//# sourceMappingURL=Dropdown.js.map